export default __webpack_public_path__ + "static/media/share.8f7deca4.png";